import { workspaceDeveloperQueryKeys as e } from "./useWorkspaceDeveloperQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { workspaceDeveloperApi as r } from "@maat/api-main";
//#region src/workspaceDeveloper/useRedriveDeveloperDeliveryMutation.ts
var i = () => {
	let i = n();
	return t({
		retry: !1,
		mutationFn: (e) => r.redriveDelivery(e),
		onSuccess: (t, n) => {
			i.invalidateQueries({ queryKey: e.deliveries() }), i.invalidateQueries({ queryKey: e.delivery(n) });
		}
	});
};
//#endregion
export { i as useRedriveDeveloperDeliveryMutation };
